import { render } from "./DataAssetTransactions.vue?vue&type=template&id=5a91f05b"
import script from "./DataAssetTransactions.vue?vue&type=script&lang=js"
export * from "./DataAssetTransactions.vue?vue&type=script&lang=js"

import "./DataAssetTransactions.vue?vue&type=style&index=0&id=5a91f05b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DataAssetTransactions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a91f05b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a91f05b', __exports__)) {
    api.reload('5a91f05b', __exports__)
  }
  
  module.hot.accept("./DataAssetTransactions.vue?vue&type=template&id=5a91f05b", () => {
    api.rerender('5a91f05b', render)
  })

}


export default __exports__